import { useEffect, useState } from 'react';
import { getErrorMessage } from '../../lib/errors';
import type { TemplatePackRead } from '../../types/api';
import { listTemplatePacks } from './templatePacksApi';

export interface TemplatePacksResult {
  packs: TemplatePackRead[];
  isLoading: boolean;
  error: string | null;
}

/** Loads the pack registry once per mount. It is deployment content — no refetching. */
export function useTemplatePacks(): TemplatePacksResult {
  const [packs, setPacks] = useState<TemplatePackRead[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    // isLoading starts true and this effect runs once, so no synchronous
    // setState is needed before the fetch settles.
    listTemplatePacks(controller.signal)
      .then((loaded) => {
        setPacks(loaded);
        setError(null);
      })
      .catch((caught: unknown) => {
        if (controller.signal.aborted) return;
        setError(getErrorMessage(caught, 'The template gallery did not load. Reload to retry.'));
      })
      .finally(() => {
        if (!controller.signal.aborted) setIsLoading(false);
      });
    return () => controller.abort();
  }, []);

  return { packs, isLoading, error };
}
